// extracted by mini-css-extract-plugin
module.exports = {"cohortTable":"styles_cohortTable__3965o","progressWrapper":"styles_progressWrapper__2Eyqn","url":"styles_url__18rSE","deletedUser":"styles_deletedUser__1kXzm"};